import FileUpload from './file-upload';

export default FileUpload;